var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h4',{domProps:{"textContent":_vm._s(_vm.rliss)}}),_vm._l((_vm.data),function(value,name){return _c('SSRSousRegion',{key:name,attrs:{"name":name,"data":value,"secteur":_vm.secteur}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }